import React, { ReactNode } from 'react';
import { Box, makeStyles } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  wrapper: {
    overflow: 'auto',
    margin: `0 -${theme.spacing(2)}px`,
    padding: `0 ${theme.spacing(2)}px`,
    '&::-webkit-scrollbar': {
      width: `${theme.spacing(1)}px`,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.grey[300],
      borderRadius: `${theme.spacing(0.25)}px`,
    },
  },
}));

type Props = { children: ReactNode };

export const SCROLLABLE_CONTENT_ID = 'scrollable-content';

export const scrollToTop = () => {
  document.getElementById(SCROLLABLE_CONTENT_ID)?.scrollTo({ top: 0, behavior: 'smooth' });
};

export const ScrollableContent = ({ children }: Props) => {
  const { wrapper } = useStyles();

  return (
    <Box my={2} className={wrapper} id={SCROLLABLE_CONTENT_ID}>
      {children}
    </Box>
  );
};
